/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://fx4najzkgnct3dkisbyjqw6bpu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:d51b1234-e20f-4e37-a248-c413b5d06806",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Cj3mYDGji",
    "aws_user_pools_web_client_id": "3kuu014om8tcrq1im7ip00tm9r",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "user-db-logs202143-appprod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "afa92map-appprod": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "afa92map-appprod"
            },
            "search_indices": {
                "items": [
                    "afa92placeindex-appprod"
                ],
                "default": "afa92placeindex-appprod"
            }
        }
    }
};


export default awsmobile;
